import _ from 'lodash';
import {connect} from 'react-redux';
import createSelector from 'helpers/createSelector';
import moment from 'moment';
import {LatestFeedList} from 'modules/feed';

export default connect(
  createSelector(
    (state, props) => ({
      model: _.get(state, 'home.instantNews.feed'),
      panel_row1_left: _.get(state, 'subject.panel_row1_left'),
      query: _.get(state, 'router.location.query'),
      subjects: _.get(state, 'subject.entities'),
      mediaTypes: _.get(state, 'mediaType.mediaTypeById'),
      mediaTypeIds: _.get(state, 'mediaType.mediaTypeIds'),
      sourceGroup: _.get(state, 'home.sourceGroup'),
      permission: _.get(state, 'me.permission'),
    })
  ,
    (state) => {
      const {panel_row1_left, checkMediaType, permission} = state;
      const subjectId = _.get(permission, 'layout.panel_row1_left')
      const subject = state.subjects[subjectId] || {};
      const mediaTypes = _.keys(_.get(subject, 'queries'));
      const model = state.model;
      let sourceGroupId = {};
      if (state.sourceGroup !== '') {
        sourceGroupId = {
          sourceGroupId: state.sourceGroup
        }
      }
      return {
        model,
        showAppend: true,
        query: {
          ...state.query,
          ...sourceGroupId,
          subjectId: subjectId,
          mediaType: 'news',
          limit: 5,
          startDate: moment().subtract(6, 'd').format("YYYY-MM-DD 00:00:00"),
          endDate: moment().format("YYYY-MM-DD 23:59:59"),
        },
      };
    }
  ),
  () => ({})
)(LatestFeedList);



/** WEBPACK FOOTER **
 ** ./src/app/modules/home/components/InstantNewsFeedContainer.js
 **/